export const API_TO_GET_ALL_PRODUCTS = "/api/products";

export const API_TO_GET_ALL_CATEGORIES = "/api/categories";
